export default "__VITE_ASSET__CaZZC7hv__"